@makeApp = (data)->
    data.popup = ''

    new Vue
        el: "#app"
        data: data
        mounted: ->
            dismiss = => @popup = '' if @popup
            document.addEventListener 'click', dismiss
            document.addEventListener 'keyup', (event) =>
                do dismiss if event.key is 'Escape'

        methods:
            showPopup: (slug)->
                if @popup is slug
                    slug = ''
                @popup = slug

@makeMenuApp = (data)->
    data.mobileShown   = false
    data.productsShown = false
    delete data.team_slides # team not needed

    new Vue
        el: "#menu-app"
        data: data

        methods:
            toggleMobile:   ->
                @mobileShown = !@mobileShown
                @productsShown = false

            toggleProducts: -> @productsShown = not @productsShown

@initPage =->
    ## fold over titles into two lines
    for h in document.querySelectorAll ".split-over"
        text    = h.innerHTML
        copy    = text.split " "
        getLens =-> copy.map (c)-> c.length
        wrap    =->
            h.classList.add 'has-single-span'
            h.innerHTML = "<span>#{text}</span>"

        switch copy.length
            when 2
                [p1, p2] = copy
                [l1, l2] = getLens()
                if l2 > l1
                    do wrap
                    continue
            when 3
                [p1, p2, p3] = copy
                [l1, l2, l3] = getLens()
                if l3 > l1 + l2
                    do wrap
                    continue

                if l1 < l2 + l3
                    p1 = "#{p1} #{p2}"
                    p2 = p3
                else p2 = "#{p2} #{p3}"
            else
                do wrap
                continue
        h.innerHTML = "<span>#{p1}</span><br><span>#{p2}</span>"

    qs = (s)-> document.querySelector s
    if fp = qs '.intro .first-paragraph'
        firstPar = qs '.main-title + p'
        fp.innerHTML = firstPar.innerHTML
        firstPar.classList.add 'to-hide'

    'done'

@wpAjaxData = (action, data, success, error, completed)->
    data =
        data:   data
        action: action
    form = new FormData
    props = (prepend, val)->
        if typeof val isnt 'object'
            form.append prepend, val
        else for k, v of val
            props "#{prepend}[#{k}]", v
        form
    props k,v for k,v of data

    req = new XMLHttpRequest
    req.onreadystatechange =->
        if req.readyState == 4
            if req.getResponseHeader('content-type') is 'application/json'
                response = JSON.parse req.response
            else response = req.response
            if req.status isnt 200
                error response if error
            else
                success response if success
    req.onload = completed if completed
    req.open "POST", "/wp-admin/admin-ajax.php"
    req.send form
